module.exports = __webpack_public_path__ + "img/48_7.f6d19419.png";